<div class="confirmation-page" *ngIf="cartSummary as summary">
  <div class="hero-card">
    <h1>Your order has been submitted</h1>
    <p>
      We received your request for {{ itemCount }} Extra XCO{{ itemCount === 1 ? '' : 's' }} (ADDP{{ itemCount === 1 ? '' : 's' }}).
    </p>
  </div>

  <section class="status-card">
    <h2>Status</h2>
    <div class="status-badge">{{ requestStatus | titlecase }}</div>
    <p class="status-message">
      Pending: you will be notified by email shortly and you can track the progress of your request in the
      <a routerLink="/market-data-ledgers">Market Data Ledger section</a> of the portal.
    </p>
  </section>

  <section class="summary-card">
    <div class="summary-header">
      <div>
        <h2>Order summary</h2>
        <p>{{ itemCount }} ADDP{{ itemCount === 1 ? '' : 's' }}</p>
      </div>
      <div class="summary-total">{{ formatCartTotal() }}</div>
    </div>
    <ul class="items">
      <li *ngFor="let item of items; trackBy: trackByItem">
        <div class="item-title">
          {{ formatItemTitle(item) }}
          <span class="item-service">{{ item.payload?.service || 'ADDP' }}</span>
        </div>
        <p class="item-meta">Quantity: {{ getQuantity(item) }}</p>
        <p class="item-meta" *ngIf="getOriginalXco(item) as originalXco">
          <span class="original-xco-label">Original XCO : {{ originalXco }} ·</span>
          <span *ngIf="getTechnicalPopName(item) as technicalPopName">&nbsp;{{ technicalPopName }}</span>
        </p>
        <p class="product-list">{{ formatProductList(item) }}</p>
      </li>
    </ul>
  </section>

  <div class="actions">
    <a class="primary-btn" routerLink="/">Back to Home</a>
  </div>
</div>
